import * as React from "react"
import { ToggleGroup as ToggleGroupPrimitive } from "radix-ui"

import { cn } from "@/lib/utils"

type ToggleGroupProps = Omit<
  Extract<React.ComponentProps<typeof ToggleGroupPrimitive.Root>, { type: "single" }>,
  "type"
> & {
  type?: "single"
}

function ToggleGroup({
  className,
  type = "single",
  ...props
}: ToggleGroupProps) {
  return (
    <ToggleGroupPrimitive.Root
      data-slot="toggle-group"
      type={type}
      className={cn(
        "inline-flex flex-wrap items-center gap-1 rounded-md bg-muted p-1 text-muted-foreground",
        className
      )}
      {...props}
    />
  )
}

function ToggleGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof ToggleGroupPrimitive.Item>) {
  return (
    <ToggleGroupPrimitive.Item
      data-slot="toggle-group-item"
      className={cn(
        "inline-flex h-8 min-w-0 items-center justify-center rounded-sm px-3 text-sm font-medium whitespace-nowrap transition-colors outline-none hover:bg-background hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-background data-[state=on]:text-foreground data-[state=on]:shadow-xs",
        className
      )}
      {...props}
    />
  )
}

export { ToggleGroup, ToggleGroupItem }
